if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.called = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        if (this.called === false) {
          this.scrollVertically();
          this.addEventListener("click", this.scroll.bind(this));
        }

        this.showActiveMedia();
        this.called = true;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
        this.modalContainer.scrollLeft = activeMedia.offsetLeft;
      }

      scrollVertically() {
        this.modalContainer = this.querySelector(
          ".product-media-modal__content"
        );
        if (!this.modalContainer) return;

        this.modalContainer.addEventListener("wheel", (evt) => {
          evt.preventDefault();
          let scrollWidth = this.modalContainer.clientWidth;
          scrollWidth = evt.deltaY > 0 ? scrollWidth : -scrollWidth;
          this.modalContainer.scrollLeft += scrollWidth;
        });
      }

      scroll(e) {
        const el = e.target.closest(".product-media-modal__arrow");
        if (!el) return;
        this.modalContainer = this.querySelector(
          ".product-media-modal__content"
        );
        if (!this.modalContainer) return;
        let scrollWidth = this.modalContainer.clientWidth;
        scrollWidth =
          el.classList.contains("arrowNext") > 0 ? scrollWidth : -scrollWidth;

        this.modalContainer.scrollLeft += scrollWidth;

        if (
          this.modalContainer.clientWidth + this.modalContainer.scrollLeft ===
          this.modalContainer.scrollWidth
        )
          this.modalContainer.scrollLeft = 0;

        if (
          el.classList.contains("arrowPrev") &&
          this.modalContainer.scrollLeft === 0
        )
          this.modalContainer.scrollLeft =
            this.modalContainer.scrollWidth - this.modalContainer.clientWidth;
      }
    }
  );
}
